import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@codex-brightworld/icons';

const Wrapper = styled.div`
  white-space: nowrap;
`;

const Count = styled.div`
  margin-left: 2px;
  font-size: 12px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  > span {
    position: relative;
    top: -2px;
  }
`;

const Item = styled.div`
  width: 13px;
  margin-right: 3px;
  display: inline-flex;

  > span {
    width: 13px;
    height: 18px;
    display: flex;
    align-items: center;
  }
`;

const returnIcon = (half, active) => {
  if (half) {
    return <Icon icon="half_star" />;
  }
  if (active) {
    return <Icon icon="star_filled_bw" />;
  }
  return <Icon icon="star_empty_bw" />;
};

class Rating extends PureComponent {

  renderItems() {
    const { props: { maxCount, ratingValue } } = this;

    const items = [];
    const hasGreaterReminder = ratingValue % 1 > 0.5;
    const hasHalfItem = hasGreaterReminder ? false : (ratingValue % 2) !== 0;
    const value = Math.round((hasHalfItem ? ratingValue - 1 : ratingValue) / 2);

    for (let i = 1; i <= maxCount; i++) {
      const active = i <= value;
      const half = hasHalfItem && (i - 1 === value);
      items.push(
        <Item
          key={`item-${i}`}
        >
          {returnIcon(half, active)}
        </Item>
      );
    }

    return items;
  }

  render() {
    const { props: { ratingCount } } = this;

    return (
      <Wrapper {...this.props} data-qa={this.props.qa}>
        {this.renderItems()}
        {ratingCount !== undefined && <Count><span>({ ratingCount })</span></Count>}
      </Wrapper>
    );
  }
}

Rating.displayName = 'Rating';

Rating.propTypes = {
  maxCount: PropTypes.number.isRequired,
  ratingCount: PropTypes.number,
  ratingValue: PropTypes.number.isRequired,
  qa: PropTypes.string
};

Rating.defaultProps = {
  ratingCount: undefined,
  qa: undefined
};

export default Rating;
